import { Trans } from '@lingui/react/macro';

import Loader from '@/components/Loader';
import { PageLayoutCenter } from '@/components/PageLayout';
import Paragraph from '@/design_system/Typography/Paragraph';

export const Loading = () => {
  return (
    <PageLayoutCenter>
      <Loader style={{ height: '40px', width: '40px' }} />
      <Paragraph>
        <Trans id="_general.loading">Loading...</Trans>
      </Paragraph>
    </PageLayoutCenter>
  );
};
